export default "__VITE_ASSET__0d81adb9__"